import {
  DATE_MODE_QUERY_PARAM,
  datesQueryParams,
  parseDateContext,
  serializeDateContext,
} from './searchDates';

const STORAGE_KEY = 'toastablyWeddingDate';
const PROMPT_DONE_STORAGE_KEY = 'toastablyWeddingDatePromptDone';

const DAY_RE = /^\d{4}-\d{2}-\d{2}$/;
const MONTH_RE = /^\d{4}-\d{2}$/;

/**
 * The wedding date a search asks about, as it is saved: '2027-06-14' for a day, '2027-06' for a
 * month. A range is not a wedding date, so it gives null.
 *
 * @param {string|null|undefined} dates `dates` query param
 * @param {string|null|undefined} dateMode `dateMode` query param
 * @returns {string|null}
 */
export const weddingDateFromSearch = (dates, dateMode) => {
  const ctx = parseDateContext(dates, dateMode);
  return ctx?.mode === 'day' ? ctx.date : ctx?.mode === 'month' ? ctx.month : null;
};

/**
 * The `dates` and `dateMode` params for a saved wedding date, or null when it is malformed or
 * has already passed.
 *
 * @param {string|null|undefined} value e.g. '2027-06-14' or '2027-06'
 * @param {Date} [now] injectable for tests
 * @returns {{ dates: string, dateMode: string|null }|null}
 */
export const weddingDateSearchParams = (value, now = new Date()) => {
  const ctx = DAY_RE.test(value || '')
    ? { mode: 'day', date: value }
    : MONTH_RE.test(value || '')
    ? { mode: 'month', month: value }
    : null;
  if (!ctx) {
    return null;
  }
  const params = serializeDateContext(ctx);
  const parsed = parseDateContext(params.dates, params[DATE_MODE_QUERY_PARAM]);
  const isUpcoming = !!parsed && Object.keys(datesQueryParams(parsed, now)).length > 0;
  return parsed?.mode === ctx.mode && isUpcoming ? params : null;
};

export const profileWeddingDate = currentUser =>
  currentUser?.attributes?.profile?.privateData?.weddingDate || null;

// localStorage can be unavailable (blocked storage, private mode); the date is then not kept.
export const readStoredWeddingDate = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return null;
  }
};

export const storeWeddingDate = value => {
  try {
    if (value) {
      window.localStorage.setItem(STORAGE_KEY, value);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch (e) {
    // Not kept, see readStoredWeddingDate.
  }
};

export const isWeddingDatePromptDone = () => {
  try {
    return !!window.localStorage.getItem(PROMPT_DONE_STORAGE_KEY);
  } catch (e) {
    return false;
  }
};

export const markWeddingDatePromptDone = () => {
  try {
    window.localStorage.setItem(PROMPT_DONE_STORAGE_KEY, '1');
  } catch (e) {
    // The prompt then only stays closed for this page view.
  }
};
